function readEnv(name: string): string | undefined {
  // `name` is a hard-coded literal at every call site below — not user input.
  // eslint-disable-next-line security/detect-object-injection
  const value = import.meta.env[name];
  return typeof value === 'string' && value.length > 0 ? value : undefined;
}

function requireEnv(name: string): string {
  const value = readEnv(name);
  if (value === undefined) {
    throw new Error(
      `Missing env var "${name}". Copy .env.example to .env and fill in your Supabase project values.`,
    );
  }
  return value;
}

function readPublishableKey(): string {
  const fresh = readEnv('VITE_SUPABASE_PUBLISHABLE_KEY');
  if (fresh !== undefined) return fresh;
  // Backwards-compat: Supabase renamed anon → publishable. Accept the legacy
  // name with a one-time warning so existing .env files keep working.
  const legacy = readEnv('VITE_SUPABASE_ANON_KEY');
  if (legacy !== undefined) {
    // eslint-disable-next-line no-console -- intentional one-time deprecation notice
    console.warn(
      'VITE_SUPABASE_ANON_KEY is deprecated. Rename it to VITE_SUPABASE_PUBLISHABLE_KEY in your .env.',
    );
    return legacy;
  }
  return requireEnv('VITE_SUPABASE_PUBLISHABLE_KEY');
}

export const env = {
  SUPABASE_URL: requireEnv('VITE_SUPABASE_URL'),
  SUPABASE_PUBLISHABLE_KEY: readPublishableKey(),
  /**
   * Cloudflare Turnstile, Phase 184. OPTIONAL by design: unset means the bot
   * gate is simply not shown, and the app works exactly as it did before.
   *
   * A missing key must never be a hard failure here. `request-institute` is a
   * public endpoint that triggers real email now, so it is throttled in the
   * DATABASE regardless — the throttle is the fail-closed half, and this is a
   * layer on top of it rather than the thing holding the door.
   */
  TURNSTILE_SITE_KEY: readEnv('VITE_TURNSTILE_SITE_KEY') ?? null,
} as const;
